import React, { Component } from 'react';
import { t } from 'ttag';
import style from './defaultBox.scss';
import Modal from '../../modal/modalComponent';
import DependencyList from '../../dependencies/dependencyListComponent';
import Price from '../../util/Price';

class DefaultBox extends Component {
    constructor(props) {
        super(props);
        this.componentWrapper = React.createRef();
        this.state = {
            modalVisibility: false,
        };
    }

    onChange = serialParentUid => {
        const { item } = this.props;
        if (item.mandatory || serialParentUid) {
            return null;
        }
        return this.props.onSelectItem(item);
    };

    showModal = () => {
        const { item } = this.props;
        if (!item.disabled) {
            return null;
        }

        return this.setState({
            modalVisibility: true,
        });
    };

    hideModal = event => {
        event.preventDefault();
        return this.setState({
            modalVisibility: false,
        });
    };

    renderName = part => {
        if (part.code !== '') {
            return `${part.name} [${part.code}]`;
        }
        return `${part.name}`;
    };

    renderWeight = part => `${part.weight} KG + `;

    render = () => {
        let isSelected = false;
        let isMarked = false;
        let isLastMarked = false;
        let containerStyle = style.container;

        const { item, configuration, selectedItems, resolvePrice, markedDependencies } = this.props;

        let serialParentUid = 0;
        for (let i = 0; i < selectedItems.length; i += 1) {
            if (selectedItems[i].uid === item.uid) {
                isSelected = true;
                serialParentUid = selectedItems[i].serial_parent_uid;
            }
        }

        for (let i = 0; i < markedDependencies.length; i += 1) {
            if (markedDependencies[i] === item.uid) {
                isMarked = true;
                // If the current element is the last
                // element that was marked, prepare it for scrolling
                if (i === markedDependencies.length - 1) {
                    isLastMarked = true;
                }
            }
        }

        if (item.disabled === true) {
            isSelected = false;
            containerStyle = style.container__disabled;
        }

        if (isSelected) {
            containerStyle = style.container__active;
        }

        if (isMarked) {
            containerStyle += ` ${style.container__marked}`;
            if (isLastMarked && this.componentWrapper.current) {
                window.scrollTo(0, this.componentWrapper.current.offsetTop - 200);
            }
        }

        return (
            <label htmlFor={item.uid} ref={this.componentWrapper}>
                <input
                    className={style.checkbox}
                    type="checkbox"
                    value={item.uid}
                    id={item.uid}
                    checked={isSelected}
                    onChange={() => this.onChange(serialParentUid)}
                />
                {item.disabled ? (
                    <Modal
                        title=""
                        showNotice="true"
                        content={
                            <DependencyList
                                item={item}
                                parts={this.props.parts}
                                configuration={configuration}
                                closeModal={this.hideModal}
                            />
                        }
                        visibility={this.state.modalVisibility}
                        closeModal={this.hideModal}
                    />
                ) : null}
                <div className={containerStyle} onClick={this.showModal}>
                    <p>{this.renderName(item)}</p>
                    <h4>
                        {this.renderWeight(item)}
                        {item.serie === 2 ? t`auf Anfrage` : null}
                        {item.serie === 1 ? t`Serie` : null}
                        {/* eslint-disable-next-line max-len */}
                        {item.serie === 0 ? <Price value={resolvePrice(item, serialParentUid)} /> : null}
                    </h4>
                </div>
            </label>
        );
    };
}

export default DefaultBox;
